import { actions, store } from "../../redux";
import { PostVideoProps } from "../../redux/slices/postVideo/postVideo";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;

const createVideoDraftForAPost = (
  payload: PostVideoProps.createVideoDraftForAPostPayload
) => {
  return API_INSTANCES.POSTVIDEO.createVideoDraftForAPost(payload)
    .then((response) => {
      const data =
        response.data as PostVideoProps.createVideoDraftForAPostResponse;
      dispatch(actions.postVideo.setUploadedVideoDraft(data.id));
    })
    .catch((error) => handleError(error, "createVideoDraftForAPost"));
};

const uploadVideoToAPost = (
  payload: PostVideoProps.uploadVideoToAPostPayload
) => {
  dispatch(actions.postVideo.setIsUploading(true));
  return API_INSTANCES.POSTVIDEO.uploadVideoToAPost(payload)
    .then((response) => {
      const data = response.data as PostVideoProps.Video;
      dispatch(actions.postVideo.setUploadedVideo(data));
    })
    .catch((error) => handleError(error, "uploadVideoToAPost"))
    .finally(() => {
      dispatch(actions.postVideo.setIsUploading(false));
    });
};

const deleteVideoFromAPost = (
  payload: PostVideoProps.deleteVideoFromAPostPayload
) => {
  return API_INSTANCES.POSTVIDEO.deleteVideoFromAPost(payload)
    .then(() => {
      dispatch(actions.postVideo.reset());
    })
    .catch((error) => handleError(error, "deleteVideoFromAPost"));
};

const getPostVideo = (post_id: string) => {
  return API_INSTANCES.POSTVIDEO.getPostVideo(post_id)
    .then((response) => {
      const data = response.data as PostVideoProps.Video;
      dispatch(actions.postVideo.setUploadedVideo(data));
    })
    .catch((error) => handleError(error, "getPostVideo"));
};
export const POSTVIDEO = {
  createVideoDraftForAPost,
  uploadVideoToAPost,
  deleteVideoFromAPost,
  getPostVideo,
};
